import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './../../../../../services/API/auth/auth.service';

@Component({
    selector: 'app-contenedores-mov',
    templateUrl: './contenedores-mov.component.html',
    styleUrls: ['./contenedores-mov.component.css'],
    standalone: false
})
export class ContenedoresMovComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    if (!this.authService.canViewMovimientos()) {
      this.router.navigate(['/dashboard/contenedores']);
    }
  }

}
